/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { SizeMe } from 'react-sizeme';
import { PdfViewer } from '../PDFViewer/PdfViewer';

export namespace DocumentViewer {
  export interface Props {
    activePdfUrl?: string;
  }
}

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    height: '100%',
  },
});

export const DocumentViewer: React.FC<DocumentViewer.Props> = ({ activePdfUrl }) => {
  return (
    <SizeMe refreshMode={'debounce'}>
      {({ size }) => (
        <div className={css(styles.wrapper)} data-it="DocumentViewer">
          {activePdfUrl ? (
            <>
              <PdfViewer fileUrl={activePdfUrl} width={Number(size.width)} />
            </>
          ) : (
            <div />
          )}
        </div>
      )}
    </SizeMe>
  );
};
